import { Component, OnInit } from '@angular/core';
import { ModalComponent } from '../../../modals/components/modal/modal.component';
import { ActiveModal } from '../../../modals/classes/active-modal';
import { ActiveModalButtons } from '../../../modals/classes/active-modal-buttons';
import { ActiveModalLoader } from '../../../modals/classes/active-modal-loader';

@Component({
    selector: 'alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss']
})
export class AlertComponent extends ModalComponent implements OnInit {

    /**
     * The alert message.
     *
     * @type {string}
     */
    public message: string;

    constructor(public modal: ActiveModal, public buttons: ActiveModalButtons, public loader: ActiveModalLoader) {
        super(modal, buttons, loader);
    }

    ngOnInit() {
        super.ngOnInit();

        this.message = this.modal.get<string>('message');
    }

}




// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/alerts/components/alert/alert.component.ts